export default function updateGridView(type) {
    axios.put(window.config.urls.settings.gridview, {type: type});
}
